module.exports = __webpack_public_path__ + "static/img/index_01.fb16e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_01.png
// module id = imGW
// module chunks = 1